import { Injectable } from '@angular/core'
import type { FeatureKey } from '@app/features/feature-keys.generated'
import { features } from '@env/tenant'

@Injectable({ providedIn: 'root' })
export class FeatureService {
  has(name: FeatureKey): boolean {
    // A flag absent from the active tenant catalog is treated as disabled:
    // `undefined === true` is false, so a missing flag safely falls back to off.
    return features[name] === true
  }

  all(): Readonly<Record<FeatureKey, boolean>> {
    return features
  }
}
